import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from 'core/components/Layout';
import ProtectedRoute from 'core/components/ProtectedRoute';
import LoginPage from 'core/pages/LoginPage';
import RegisterPage from 'core/pages/RegisterPage';
import OverviewPage from 'core/pages/OverviewPage';
import NotFoundPage from 'core/pages/NotFoundPage';
import { MODULES } from 'modules';

/**
 * Routen-Definition des Portals.
 *
 * Der allgemeine Teil (Login, Registrierung, Übersicht, 404) liegt in
 * src/core. Alle Projekt-Routen kommen aus der Modul-Registry
 * (src/modules/index.js) – jedes Modul liefert seine Routen selbst mit.
 *
 * ▶ NEUES MODUL VERDRAHTEN: nichts hier ändern, nur in
 *   src/modules/index.js registrieren.
 *
 * `/login` und `/register` sind öffentlich; alle übrigen Seiten liegen hinter
 * der Benutzerverwaltung (<ProtectedRoute>).
 */
export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<OverviewPage />} />
          {MODULES.map((modul) => (
            <React.Fragment key={modul.id}>{modul.routes}</React.Fragment>
          ))}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Layout>
  );
}
